export default __webpack_public_path__ + "static/media/dpr.eb87937e.svg";